// extracted by mini-css-extract-plugin
export default {"sideText":"index_sideText_w5m7U","sideTextScroll":"index_sideTextScroll_l3Evu","sideTextItem":"index_sideTextItem_GrTh-"};